import { render, staticRenderFns } from "./VWeekPicker.vue?vue&type=template&id=09f2bf23&scoped=true&"
import script from "./VWeekPicker.vue?vue&type=script&lang=ts&"
export * from "./VWeekPicker.vue?vue&type=script&lang=ts&"
import style0 from "./VWeekPicker.vue?vue&type=style&index=0&id=09f2bf23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f2bf23",
  null
  
)

export default component.exports